/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Green_House_Grizzly_SpurInputs */

const en_green_house_grizzly_spur = /** @type {(inputs: Green_House_Grizzly_SpurInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organization`)
};

const de_green_house_grizzly_spur = /** @type {(inputs: Green_House_Grizzly_SpurInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organisation`)
};

/**
* | output |
* | --- |
* | "Organization" |
*
* @param {Green_House_Grizzly_SpurInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const green_house_grizzly_spur = /** @type {((inputs?: Green_House_Grizzly_SpurInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Green_House_Grizzly_SpurInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_green_house_grizzly_spur(inputs)
	return de_green_house_grizzly_spur(inputs)
});